class SmoothScroll {
	constructor() {
		smoother = ScrollSmoother.create({
			content: "#content",
			wrapper: "#viewport",
			smooth: 0.8,
			effects: true
		});

		ScrollTrigger.matchMedia({
			"(max-width: 767px)": () => {
				smoother.effects("[data-speed-restore]", {speed: "1", lag: 0});

				const restoredParallax = document.querySelectorAll("[data-speed-restore]");
				restoredParallax.forEach((elem) => {
					elem.style.removeProperty("transform");
				});
			},
			"(min-width: 768px)": () => {
				const restoredParallax = document.querySelectorAll("[data-speed-restore]");
				restoredParallax.forEach((elem) => {
					smoother.effects(elem, {speed: elem.dataset.speedRestore, lag: elem.dataset.lagRestore});
				});
			}
		});
	}
}
